<template>
  <div class="container">
    <slot></slot>
    <!-- <div class='footer'>
        <img src="@/assets/img/techsupport.png" alt="">
    </div>-->
    <div v-if="isTopBtn && showScrollTopBtn" class="two-btn-content one">
      <!-- <div class='share-poster'>
        <div class='image-filter'></div>
        <img class='share-poster-image' src='@/assets/img/icon_share_white.png' />
        <div class='share-image-item-content'>
        </div>
      </div>-->
      <div v-if="isTopBtn && showScrollTopBtn" class="back-top" @click="scrollTopAction">
        <div class="image-filter"></div>
        <img class="back-top-image" src="@/assets/img/icon_back_up_white.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['isTopBtn'],
  data() {
    return {
      showScrollTopBtn: false,
      scrollTop: 0,
    };
  },
  mounted() {
    if (this.isTopBtn) {
      window.addEventListener('scroll', this.scrollToTop);
    }
  },
  destroyed() {
    if (this.isTopBtn) {
      window.removeEventListener('scroll', this.scrollToTop);
    }
  },

  methods: {
    scrollTopAction() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 200) {
        that.showScrollTopBtn = true;
      } else {
        that.showScrollTopBtn = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  min-height: 100%;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  position: relative;
  .footer {
    // position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
    padding-bottom: 100px;
    text-align: center;
    display: flex;
    justify-content: center;
    img {
      display: inline-block;
      width: 128px;
      height: 13px;
    }
  }
  .scroll-top {
    width: 44px;
    height: 44px;
    position: fixed;
    right: 12px;
    bottom: 156px;
    border-radius: 22px;
    /* background: rgba(255, 255, 255, 0.95); */
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
    /* filter: blur(1px); */
    margin-bottom: env(safe-area-inset-bottom);
  }

  .image-filter {
    width: 100%;
    height: 100%;
    border-radius: 20px;
    background-image: rgba(255, 255, 255, 1);
  }

  .scroll-top-image {
    position: absolute;
    width: 20px;
    height: 20px;
    // right: 12px;
    // top: 12px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .two-btn-content {
    width: 44px;
    height: 88px;
    position: fixed;
    right: 16px;
    bottom: 68px;
    border-radius: 22px;
    background: rgba(34, 34, 34, 0.5);
    /* box-shadow: 0rpx 10rpx 30rpx rgba(0, 0, 0, 0.15); */
    z-index: 90;
    margin-bottom: constant(safe-area-inset-bottom);
    margin-bottom: env(safe-area-inset-bottom);
    border: 1px solid rgba(238, 238, 238, 1);
  }
  .two-btn-content.one {
    height: 44px;
  }
  .two-btn-content.two {
    height: 88px;
  }

  .back-top {
    width: 44px;
    height: 44px;
    position: absolute;
    right: 0px;
    bottom: 0px;
  }

  .back-top-image {
    position: absolute;
    width: 20px;
    height: 20px;
    // right: 12px;
    // top: 12px;
    left: 50%;
    top: 50%;
    display: block;
    transform: translate(-45%, -50%);
  }

  .share-poster {
    width: 44px;
    height: 44px;
    position: absolute;
    right: 0px;
    top: 0px;
  }

  .share-poster-image {
    position: absolute;
    width: 20px;
    height: 20px;
    right: 12px;
    bottom: 12px;
  }

  .share-image-item-content {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
  }

  .hidd {
    background: transparent;
    background-color: transparent;
  }
}
</style>
